import { createSlice, createAction } from '@reduxjs/toolkit';
import { API } from 'store/middleware/api';
import { PAGES } from 'store/pages/slice';
import { SEARCH } from 'store/search/actions';
import { BOOKINGS } from 'store/bookings/slice';
import { FACILITIES } from 'store/facilities/actions';

export const UNITS = {
	LOOKUP_REQUEST: 'SFDC/UNITS/LOOKUP_REQUEST',
	LOOKUP_SUCCESS: 'SFDC/UNITS/LOOKUP_SUCCESS',
	LOOKUP_FAILURE: 'SFDC/UNITS/LOOKUP_FAILURE'
};

export const initialState = {
	loading: false,
	error: false,
	errorMessage: null,
	byId: {}
};

const UNIT_SUCCESS_TYPES = [
	FACILITIES.SUCCESS,
	FACILITIES.FACILITY_PAGE_SUCCESS,
	SEARCH.SUCCESS,
	SEARCH.SEARCH_LANDING_SUCCESS,
	SEARCH.STORAGE_DEALS_SUCCESS,
	SEARCH.PAGE_SUCCESS,
	PAGES.BOOKING_PAGE_SUCCESS,
	PAGES.MOVE_IN_CONFIRM_STATUS_PAGE_SUCCESS,
	BOOKINGS.RECENT_BOOKING_SUCCESS,
	BOOKINGS.FROM_CONFIRMATION_CODE_SUCCESS,
	UNITS.LOOKUP_SUCCESS,
	PAGES.CAR_PSP_PAGE_SUCCESS,
	PAGES.STORAGE_PAGE_SUCCESS,
	PAGES.UNIT_PAGE_SUCCESS,
	PAGES.MOVING_TRUCK_PAGE_SUCCESS,
	PAGES.MOVING_TRUCK_CLP_SUCCESS,
];

const unitsSlice = createSlice({
	name: 'units',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addMatcher(
			(action) => UNIT_SUCCESS_TYPES.includes(action.type),
			(state, action) => ({
				...state,
				byId: {
					...state.byId,
					...action.payload.entities.units
				}
			})
		);
	}
});

export const unitLookupSuccess = createAction(UNITS.LOOKUP_SUCCESS);
export const unitLookupFailure = createAction(UNITS.LOOKUP_FAILURE);

export function lookupUnit(facilityId, unitId) {
	return {
		[API]: {
			types: [UNITS.LOOKUP_REQUEST, UNITS.LOOKUP_SUCCESS, UNITS.LOOKUP_FAILURE],
			endpoint: `/unitPage/${facilityId}/${unitId}`
		}
	};
}

export default unitsSlice.reducer;
